var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdgeBerryLogoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2600,
    height: 500,
    viewBox: "0 0 687.91 132.29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    transform: "scale(.26458)",
    fill: "none",
    fontFamily: "'Liberation Sans'",
    fontSize: "40px",
    letterSpacing: "0px",
    stroke: "#000000",
    strokeWidth: "1px",
    "text-align": "center",
    wordSpacing: "0px",
    style: {
      lineHeight: "125%",
      shapeInside: "url(#rect15835)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("text", {
    x: 411.6904,
    y: 98.270645,
    fill: "#0007ff",
    fontFamily: "'Liberation Sans'",
    fontSize: "10.583px",
    letterSpacing: "0px",
    stroke: "#000000",
    strokeWidth: ".26458px",
    "text-align": "center",
    textAnchor: "middle",
    wordSpacing: "0px",
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 411.6904,
    y: 98.270645,
    fill: "#0007ff",
    fontFamily: "Lato",
    fontSize: "88.194px",
    fontWeight: 900,
    stroke: "none",
    strokeWidth: ".26458px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "EDGEBERRY")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(404.42 133.59)",
    fill: "#0007ff",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    x: -395.23,
    y: 37.622,
    width: 19.338,
    height: 46.894,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -373.32,
    y: -91.921,
    width: 19.338,
    height: 46.894,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -351.3,
    y: -126.6,
    width: 19.338,
    height: 103.3,
    strokeWidth: 0.7421
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: -329.19,
    y: -63.662,
    width: 19.338,
    height: 46.894
  }), /*#__PURE__*/React.createElement("rect", {
    x: -307.43,
    y: -54.215,
    width: 19.338,
    height: 46.894
  }), /*#__PURE__*/React.createElement("rect", {
    x: -285.64,
    y: -60.124,
    width: 19.338,
    height: 46.894
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeBerryLogoText);
export default __webpack_public_path__ + "static/media/EdgeBerry_Logo_text.4d8ed307b6b2f6bbe07655b248224349.svg";
export { ForwardRef as ReactComponent };